import { ThemeProvider, CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import theme from 'core/theme';
import AppRouter from 'core/router/AppRouter';
import { GlobalSnackbarProvider, GlobalConfirmProvider } from 'components/GlobalSnackbar';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalSnackbarProvider>
          <GlobalConfirmProvider>
            <AppRouter />
          </GlobalConfirmProvider>
        </GlobalSnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
